export const POIFieldsList = [
  { label: "Point of Interest Group Name", key: "categoryName" },
  { label: "Address", key: "addressLine1" },
  { label: "Address Line 2", key: "addressLine2" },
  { label: "City", key: "city" },
  { label: "State", key: "state" },
  { label: "Zip", key: "postalCode" },
  { label: "Latitude", key: "latitude" },
  { label: "Longitude", key: "longitude" },
  { label: "Location Notes", key: "locationNotes" },
];

export default POIFieldsList;

// Header mapping for Excel import auto-matching
export const POIHeaderMapping: Record<string, string> = {
  "Point of Interest Group Name": "categoryName",
  "POI Group": "categoryName",
  "Group Name": "categoryName",
  Category: "categoryName",
  "Category Name": "categoryName",
  Address: "addressLine1",
  "Address Line 1": "addressLine1",
  "Address 1": "addressLine1",
  "Street Address": "addressLine1",
  Street: "addressLine1",
  "Address Line 2": "addressLine2",
  "Address 2": "addressLine2",
  Suite: "addressLine2",
  City: "city",
  State: "state",
  "State/Province": "state",
  Province: "state",
  Zip: "postalCode",
  "Zip Code": "postalCode",
  "Postal Code": "postalCode",
  ZIP: "postalCode",
  Latitude: "latitude",
  Longitude: "longitude",
  Lat: "latitude",
  Lng: "longitude",
  Long: "longitude",
  "Location Notes": "locationNotes",
  Notes: "locationNotes",
};

/**
 * Generate the default header mapping array for the parsepoi API call.
 * Returns all known header aliases as { header, matchedAttribute } pairs.
 */
export function generatePOIHeaderMapping(): Array<{
  header: string;
  matchedAttribute: string;
}> {
  return Object.entries(POIHeaderMapping).map(([header, matchedAttribute]) => ({
    header,
    matchedAttribute,
  }));
}
